import type { IPadlockIconProps } from './helpers';

export const PadlockIcon = ({ variant = 'default', ...rest }: IPadlockIconProps) => {
	if (variant === 'default') {
		return (
			<svg
				width='120'
				height='120'
				viewBox='0 0 120 120'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...rest}
			>
				<g opacity='0.7'>
					<path
						d='M26.3022 33.6919V67.6974H93.6898V33.6919C93.6898 15.1153 78.5746 0 59.9941 0C41.4137 0 26.3022 15.1153 26.3022 33.6919ZM31.9705 33.6919C31.9705 18.2139 44.5161 5.66444 59.9941 5.66444C75.4722 5.66444 88.0178 18.2139 88.0178 33.6919V62.0292H31.9705V33.6919Z'
						fill='#F3F3F3'
					/>
					<path
						d='M31.9707 33.6915V62.0288H88.0218V33.6915C88.0218 18.2135 75.4762 5.66406 59.9982 5.66406C44.5201 5.66406 31.9707 18.2135 31.9707 33.6915ZM37.6389 33.6915C37.6389 21.365 47.6679 11.3361 59.9982 11.3361C72.3284 11.3361 82.3574 21.365 82.3574 33.6915V56.3606H37.6389V33.6915Z'
						fill='#E5E5E5'
					/>
					<path
						d='M22.3911 120H97.6084C101.78 120 105.166 116.618 105.166 112.442V57.8193C105.166 53.6475 101.78 50.2617 97.6084 50.2617H22.3911C18.2155 50.2617 14.8335 53.6475 14.8335 57.8193V112.442C14.8335 116.618 18.2155 120 22.3911 120Z'
						fill='#FFCC5B'
					/>
					<path
						d='M73.1559 89.9656H76.0165C78.4425 89.9656 80.4075 87.9893 80.3924 85.5633V85.261V85.1967C80.4075 82.6422 78.3291 80.5526 75.7784 80.5526H72.079C69.2524 80.5526 66.7168 78.4364 66.5695 75.6136C66.4108 72.6019 68.8065 70.1117 71.7842 70.1117H85.131C87.6552 70.1117 89.5371 67.9918 89.5069 65.4675C89.5069 65.4486 89.5069 65.426 89.5069 65.4033C89.5069 65.3806 89.5069 65.3617 89.5069 65.3391C89.5371 62.8148 87.6552 60.6987 85.131 60.6987H80.8156C77.989 60.6987 75.4535 58.5825 75.3061 55.7598C75.1474 52.748 77.5431 50.2578 80.5208 50.2578H97.6086C101.78 50.2578 105.166 53.6399 105.166 57.8154V112.438C105.166 116.614 101.78 119.996 97.6086 119.996H75.4761C72.5929 119.996 70.2538 117.657 70.2538 114.773C70.2538 111.89 72.5929 109.551 75.4761 109.551H82.4594C84.874 109.551 86.839 107.575 86.8277 105.16V105.104C86.8277 104.998 86.8315 104.892 86.839 104.786C86.9826 102.405 85.0932 100.399 82.7088 100.399H73.4507C70.6241 100.399 68.0885 98.2827 67.9412 95.46C67.7862 92.4558 70.182 89.9656 73.1559 89.9656Z'
						fill='#FDBC4B'
					/>
					<path
						d='M48.6426 78.6932C48.6426 72.4204 53.7289 67.3379 59.9979 67.3379C66.2707 67.3379 71.3532 72.4242 71.3532 78.6932C71.3532 82.8802 69.0595 86.5003 65.685 88.469L67.2419 102.923H52.7501L54.307 88.469C50.9325 86.5003 48.6426 82.8839 48.6426 78.6932Z'
						fill='#464646'
					/>
					<path
						d='M26.3023 78.3145C28.3882 78.3145 30.0811 80.0036 30.0811 82.0933V103.837C30.0811 105.926 28.3882 107.615 26.3023 107.615C24.2163 107.615 22.5234 105.926 22.5234 103.837V82.0933C22.5234 80.0074 24.2163 78.3145 26.3023 78.3145Z'
						fill='#FFD769'
					/>
					<path
						d='M26.3023 62.6445C28.3882 62.6445 30.0811 64.3337 30.0811 66.4233V70.8483C30.0811 72.938 28.3882 74.6272 26.3023 74.6272C24.2163 74.6272 22.5234 72.938 22.5234 70.8483V66.4233C22.5234 64.3337 24.2163 62.6445 26.3023 62.6445Z'
						fill='#FFD769'
					/>
				</g>
			</svg>
		);
	}

	return (
		<svg
			width='80'
			height='80'
			viewBox='0 0 80 80'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M32.3798 7.31875C39.7953 7.31875 45.875 13.3828 45.875 20.7791V30.9952H53.2127V20.7791C53.2128 9.34015 43.8439 0 32.3798 0C20.9158 0 11.5469 9.34015 11.5469 20.7791V30.9952H18.8845V20.7791C18.8847 13.3828 24.9644 7.31875 32.3798 7.31875Z'
				fill='#DEDBEE'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M53.2127 20.7791C53.2127 9.34015 43.8438 0 32.3797 0C30.033 0 27.773 0.392344 25.6641 1.11328C26.5058 1.00828 27.3613 0.953594 28.2305 0.953594C39.6945 0.953594 49.0634 10.2983 49.0634 21.7327V30.9952H53.2127V20.7791Z'
				fill='#D2CFE9'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M10.6653 29.3906C6.33766 29.3906 2.79688 32.9222 2.79688 37.2387V48.915C2.79688 65.145 16.1091 78.4228 32.3811 78.4228C37.9164 78.4228 43.1086 76.8852 47.5461 74.2205L61.9653 46.3416V37.2387C61.9653 32.9223 58.4245 29.3906 54.0969 29.3906C39.6183 29.3906 25.1441 29.3906 10.6653 29.3906Z'
				fill='#FDB441'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M32.3811 40.8672C28.8448 40.8672 25.9766 43.7234 25.9766 47.2506C25.9766 49.5275 27.1705 51.5214 28.9638 52.6575L27.6195 61.3938C27.5758 61.6777 27.7955 61.9338 28.0828 61.9338H36.6791C36.9664 61.9338 37.1861 61.6777 37.1423 61.3938L35.7981 52.6575C37.5914 51.5214 38.7853 49.5273 38.7853 47.2506C38.7856 43.7234 35.9173 40.8672 32.3811 40.8672Z'
				fill='#025F80'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M60.2875 46.2578C50.9461 46.2578 43.375 53.8092 43.375 63.1266C43.375 67.3745 44.9487 71.253 47.5425 74.2188C50.6441 77.7595 55.205 79.9998 60.2875 79.9998C69.6289 79.9998 77.2045 72.4437 77.2045 63.1266C77.2045 54.375 70.5209 47.1795 61.9619 46.34C61.4128 46.2852 60.8547 46.2578 60.2875 46.2578Z'
				fill='#01D0FB'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M31.3281 40.9494C33.7344 41.8847 35.4453 44.2483 35.4453 47.0134C35.4453 49.3267 34.2514 51.3527 32.4581 52.507L33.8855 61.9338H36.6786C36.9659 61.9338 37.1856 61.6777 37.1419 61.3938L35.7977 52.6575C37.5909 51.5214 38.7848 49.5273 38.7848 47.2506C38.7848 43.7236 35.9166 40.8672 32.3803 40.8672C32.0236 40.8672 31.6713 40.8945 31.3281 40.9494Z'
				fill='#024C67'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M77.2044 63.1266C77.2044 54.375 70.5208 47.1795 61.9617 46.34C61.4128 46.2853 60.8547 46.2578 60.2873 46.2578C59.0934 46.2578 57.9222 46.3809 56.7969 46.6183C65.3331 47.4761 71.9984 54.6625 71.9984 63.4048C71.9984 71.5267 66.2389 78.307 58.5764 79.9131C59.1391 79.9678 59.7109 79.9998 60.2873 79.9998C69.6287 79.9998 77.2044 72.4437 77.2044 63.1266Z'
				fill='#01C0FA'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M61.9642 37.2388C61.9642 32.9223 58.4234 29.3906 54.0958 29.3906H53.2128H49.0636H45.875C50.2027 29.3906 53.7434 32.9222 53.7434 37.2388V47.5691C54.7178 47.163 55.7425 46.8391 56.7994 46.62C57.9247 46.3828 59.0958 46.2595 60.2898 46.2595C60.857 46.2595 61.4152 46.2869 61.9642 46.3417V37.2388Z'
				fill='#FE9901'
			/>
			<path
				d='M60.2878 69.7381C59.6209 69.7381 59.0806 69.1977 59.0806 68.5309V63.1011C59.0806 62.4344 59.6211 61.8939 60.2878 61.8939C61.3991 61.8939 62.4317 61.4505 63.1961 60.6456C63.9547 59.8466 64.3409 58.7997 64.2836 57.6977C64.1748 55.6234 62.4572 53.9653 60.3733 53.9233C60.3455 53.9227 60.3175 53.9223 60.2897 53.9223C58.2973 53.9223 56.6022 55.3822 56.328 57.3498C56.3025 57.5384 56.2894 57.7281 56.2894 57.9086C56.2894 58.5753 55.7489 59.1158 55.0822 59.1158C54.4155 59.1158 53.875 58.5753 53.875 57.9086C53.875 57.6203 53.8956 57.3217 53.9361 57.0214C54.3838 53.8102 57.1711 51.4455 60.4225 51.5091C63.7647 51.5766 66.5202 54.2395 66.695 57.5716C66.7872 59.3419 66.1666 61.0238 64.9475 62.3078C64.0206 63.2839 62.8044 63.9405 61.4953 64.1927V68.5308C61.495 69.1975 60.9547 69.7381 60.2878 69.7381Z'
				fill='#F4EAFA'
			/>
			<path
				d='M60.2948 74.7469C60.2288 74.7469 60.1621 74.7416 60.0948 74.7304C59.4373 74.6207 58.9929 73.9987 59.1026 73.3412L59.1071 73.3138C59.2166 72.6562 59.8371 72.2112 60.4963 72.3215C61.1538 72.4312 61.5982 73.0532 61.4887 73.7107L61.4841 73.738C61.3857 74.3285 60.8743 74.7469 60.2948 74.7469Z'
				fill='#F4EAFA'
			/>
		</svg>
	);
};
